<template>
  <h5>
    <slot></slot>
  </h5>
</template>

<script>
export default {
  name: "H5",
  props: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
h5 {
  font-size: $font-size-lg;
  font-weight: 600;
  color: $black;
}
</style>
